import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment'
import { WindowRef } from 'app/_services/native-window.service';
import moment from 'moment';
import { DatePipe } from '@angular/common';

const API_URL = environment.apiUrl

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    providers: [DatePipe],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TableComponent implements OnInit, OnChanges {
  @Input() actionHeadingTemplate: TemplateRef<unknown>;
  @Input() actionsTemplate: TemplateRef<unknown>;
  @Input() customFilterTemplate: TemplateRef<unknown>;
  @Input() rowTemplate: TemplateRef<unknown>;
  @Input() addItemTemplate: TemplateRef<unknown>;
  @Input() pdfExport: boolean;
  @Input() csvExport: boolean;
  @Input() mainTitle: any;
  @Input() subtitle: any;
  @Input() rows: any;
  @Input() columns: any;
  @Input() settings: any;
  @Input() name: any;

  @Input() regionFilter: any;
  @Input() forestFilter: any;
  @Input() startDateFilter: any;
  @Input() endDateFilter: any;

  loading = false;
  nativeWindow: any;
  selected;
  details = [];
  searching = true;
  query;
  hasBeenFiltered;
  originalRows;

  // pagination vars
  start = 0;
  numberOfRows = {
    name: '10',
    value: 10
  };

  reportRows = '';

  constructor(private readonly router: Router, private readonly winRef: WindowRef,private readonly datePipe: DatePipe

    ) { this.nativeWindow = winRef.getNativeWindow(); }

  ngOnInit(): void {
    let rowsDisplayed = '10';
    this.numberOfRows = {
      name: rowsDisplayed,
      value: Number(rowsDisplayed)
    };
    this.start = 0;
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.rows) {
      this.query = '';
      this.rows = change.rows.currentValue;
      this.originalRows = this.rows;
      if (this.start > this.rows?.length) {
        this.start = 0;
      }

      // ensure every table cell has a sortable value
      this.rows?.forEach((row) => {
        this.columns?.forEach((column) => {
          if (row[column.key] === undefined || row[column.key] === null) {
            row[column.key] = '';
          }
        });
      });
    }
  }

  getCellData = (column, row) => {
    let displayValue = row[column.key];
    if (column.friendly) {
      displayValue = row[column.friendly];
    }
    return displayValue;
  };

  sort = (column) => {
    // sort selected column
    this.rows.sort((a, b) => {
      const keyA = a[column.key];
      const keyB = b[column.key];
      if (typeof keyA === 'string' && typeof keyB === 'string') {
        if (keyA?.toLowerCase() < keyB?.toLowerCase()) {
          return column.descendingOrder ? 1 : -1;
        }
        if (keyA?.toLowerCase() > keyB?.toLowerCase()) {
          return column.descendingOrder ? -1 : 1;
        }
      } else if (typeof keyA === 'number' && typeof keyB === 'number') {
        if (!column.descendingOrder) {
          return keyA - keyB;
        } else {
          return keyB - keyA;
        }
      }
      return 0;
    });
    column.descendingOrder = !column.descendingOrder;
  };

  onKey = (event) => {
    this.rows = this.textFilter(event)
  }

  textFilter = (event) => {
    if (!this.searching) {
      this.query = null;
      return;
    }
    // always filter against the original set of rows
    if (!this.hasBeenFiltered) {
      this.hasBeenFiltered = true;
      this.originalRows = this.rows;
    }
    let rows = this.originalRows;

    // find rows that match query
    // **
    // this implementation will filter rows based on what columns are added to the table
    // loop through the keys in the row instead to filter against all the row data instead of just what's shown in the columns fields
    let filteredRows = [];
    for (const key in this.columns) {
      // do not filter on 'product' per PM request
      if (this.columns.hasOwnProperty(key) && this.columns[key].key !== 'product') {
        let column = this.columns[key];
        let colKey = column.key;
        let friendlyKey = column.friendly
        rows?.forEach((row) => {
          if (!row[colKey]) {
            return;
          }
          let value = row[colKey].toString().toLowerCase();
          // filter dates against friendly value instead of timestamp
          if (column?.type === 'date') {
            let date = new Date(row[colKey])
            value = date.toLocaleDateString()
          }
          // filter permit numbers against the value displayed in the table, not the raw data
          if (colKey === 'forestPermitNumber') {
            value = `E${value.toString().padStart(5,"0")}`.toLowerCase()
          }

          // match first name as well as first name and last name
          if (colKey === 'firstName') {
            value = `${row['firstName']} ${row['lastName']}`.toString().toLowerCase();
          }

          // match last name as well as last name and first name
          if (colKey === 'lastName') {
            value = `${row['lastName']} ${row['firstName']}`.toString().toLowerCase();
          }

          let friendlyValue = row[friendlyKey]?.toString().toLowerCase()
          if (value.includes(this.query.toLowerCase()) || friendlyValue?.includes(this.query.toLowerCase())) {
            filteredRows.push(row);
          }

        });
      }
    }

    this.start = 0

    // dedupe rows
    let uniqueRows = [...new Set(filteredRows)];
    rows = uniqueRows;
    return rows
  };

  selectRow = (row) => {
    this.details = [];
    for (const key in row) {
      if (row.hasOwnProperty(key)) {
        this.details.push({ key: key, value: row[key] });
      }
    }
    this.selected = row;
  };

  pageLeft = () => {
    this.start = this.start - this.numberOfRows.value;
    if (this.start < 0) {
      this.start = 0;
    }
  };

  pageRight = () => {
    let visibleRowsCount = this.getNumberOfVisibleRows()
    if (this.start + this.numberOfRows.value * 2 >= visibleRowsCount) {
      if (this.start + this.numberOfRows.value <= visibleRowsCount - 1) {
        this.start = this.start + this.numberOfRows.value
      }
    } else {
      this.start = this.start + this.numberOfRows.value;
    }
  };

  showNumberOfRows = (event) => {
    if (event.value === 'all') {
      this.numberOfRows = {
        name: 'All',
        value: this.getNumberOfVisibleRows()
      }
    } else {
      this.numberOfRows = event
    }
    this.start = 0
    window.scrollTo(0, 400)
  }

  getNumberOfVisibleRows = () => {
    let rows = this.rows
    return rows?.length
  }

  exportCSV = () => {
    let csvData = '';
    let keys = []
    let headers = []
    if (!this.rows.length) {
      return
    }

    this.loading = true

    csvData += 'Forest Service E-Permits Report' + '\n'
    if (this.name === 'permits') { csvData += 'Permits Purchased' + '\n'  }
    if (this.name === 'users') { csvData += 'E-Permits Users' + '\n'  }
    csvData += 'Region: ' + this.regionFilter.label + '\n'
    csvData += 'Forest: ' + this.forestFilter.label + '\n'
    const date = new Date();
    csvData += `Date: ${moment(date).format('MM/DD/YYYY')} ${date.toLocaleTimeString()}` + '\n'
    if (this.name == 'permits') {
      csvData += `Date Range: ${this.getDateRangeText()}` + '\n'
    }

    // create header row and table row keys
    for (const column in this.columns) {
      keys.push(this.columns[column].key)
      headers.push(this.columns[column].label)
    }
    csvData += headers.join(',') + '\n'


    // create table rows
    for (const element of this.rows) {
      const row = element;
      csvData += keys.map((key) => {
        let cell = row[key] === null || row[key] === undefined ? '' : row[key]
        // handle unit type
        if (cell !== '' && key === 'productUnitType') {
          cell = ` ${row.productUnitType === 'Cord' ? 'Cords' : 'CCF'}`
        }
        // handle forest permit number padding
        if (cell !== '' && key === 'forestPermitNumber') {
          cell = `E${row.forestPermitNumber.toString().padStart(5, "0")}`
        }
        // handle purchase date
        if (cell !== '' && key === 'purchaseDate') {
          const purchDate: Date = new Date(row.purchaseDate);
          const purchDateString = purchDate.toLocaleDateString();
          cell = `${purchDateString}`
        }
        // format date added
        if (cell !== '' && key === 'createdAt') {
          const date = new Date(row.createdAt)
          cell = moment(date).format('MM/DD/YYYY');
        }
        return `${cell}`
      })
      csvData += '\n'
    }

    // create file and start download
    const blob = new Blob([csvData], {type: 'text/csv;charset=utf-8'})
    this.loading = false
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    let fileName = '';
    if (this.name === 'permits') { fileName = 'permits-report' }
    if (this.name === 'users') { fileName = 'users-report' }
    link.setAttribute('download', `${fileName}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  getDateRangeText() {
    let transformedStart = this.startDateFilter ? this.datePipe.transform(this.startDateFilter, 'MM/dd/yy') : null;
    let transformedEnd = this.endDateFilter ? this.datePipe.transform(this.endDateFilter, 'MM/dd/yy') : null;

    if (!transformedStart && !transformedEnd) return 'All';
    if (!transformedStart && transformedEnd) return 'Before ' + transformedEnd;
    if (transformedStart && !transformedEnd) return 'After ' + transformedStart;
    return transformedStart + ' - ' + transformedEnd;
  }

  getNumberOfPages = () => {
    return Math.ceil(this.getNumberOfVisibleRows() / this.numberOfRows.value)
  }

  getCurrentPage = () => {
    let currentPage = Math.ceil(this.start / this.numberOfRows.value) + 1
    if (currentPage > this.getNumberOfPages()) {
      currentPage = this.getNumberOfPages()
    }
    return currentPage
  }

  goToFirstPage = () => {
    this.start = 0
  }

  goToLastPage = () => {
    this.start = this.numberOfRows.value * (this.getNumberOfPages() - 1)
  }

  goPages = (amount) => {
    let restart = this.start + (this.numberOfRows.value * amount)
    this.start = restart
  }

  exportPDF = () => {
    if (this.name === 'permits') {
      this.exportPDFReport('pdf/permits-report', 'permits-report.pdf');
    } else if (this.name === 'users') {
      this.exportPDFReport('pdf/users-report', 'users-report.pdf');
    }
  };

  exportPDFReport = (route: string, fileName: string) => {
    const time = new Date().toLocaleTimeString();
    fetch(environment.apiUrl + route, {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        regionFilter: this.regionFilter,
        forestFilter: this.forestFilter,
        time,
        startDateFilter: this.startDateFilter ? this.datePipe.transform(this.startDateFilter, 'MM/dd/yy') : null,
        endDateFilter: this.endDateFilter ? this.datePipe.transform(this.endDateFilter, 'MM/dd/yy') : null
      })
    })
    .then(res => {
      return res.arrayBuffer();
    })
    .then(res => {
      const blob = new Blob([res], { type: "application/pdf" })
      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }).catch((error) => {
      console.log(error)
    })
  }
}
